var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useState, useEffect, useCallback, useRef, useMemo } from "react";
import { api_service } from "../../api/api_service";
import { api_urls } from "../../api/api_urls";
import { NavigationConfig, } from "../../utils/navigation_config";
import { BacklogStatusGroups } from "../../config/constants";
import moment from "moment";
import _ from "../../utils/lodash";
import { useSelector, useDispatch } from "react-redux";
import { backlog_actions } from "../../actions/backlog_actions";
export var fetchBacklogUniqueStatusOptions = function () { return __awaiter(void 0, void 0, void 0, function () {
    var res, response, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, api_service.get({ endPoint: api_urls.BACKLOG_UNIQUE_STATUS_LIST })];
            case 1:
                res = _a.sent();
                if ((res === null || res === void 0 ? void 0 : res.data) && res.data.statusCode === 200) {
                    response = res.data.data;
                    if (response) {
                        return [2, response.map(function (statusObj) { return ({
                                label: statusObj.Status,
                                value: statusObj.OId,
                                statusGroup: statusObj.StatusGroup,
                            }); })];
                    }
                }
                return [2, []];
            case 2:
                err_1 = _a.sent();
                console.log("fetchUniqueStatusList error:", err_1);
                return [2, []];
            case 3: return [2];
        }
    });
}); };
var DEALER_LIST_PAGE_SIZE = 100;
export function useBacklogApplication(options) {
    var _this = this;
    if (options === void 0) { options = {}; }
    var dealCategory = options.dealCategory;
    var dispatch = useDispatch();
    var filterState = useSelector(function (state) { return state.BacklogFilter; });
    var _a = useState([]), backlogAppList = _a[0], setBacklogAppList = _a[1];
    var _b = useState(false), isFetching = _b[0], setIsFetching = _b[1];
    var _c = useState(null), selectedPortal = _c[0], setSelectedPortal = _c[1];
    var _d = useState(undefined), vendorList = _d[0], setVendorList = _d[1];
    var _e = useState(0), totalCount = _e[0], setTotalCount = _e[1];
    var _f = useState([]), programsList = _f[0], setProgramsList = _f[1];
    var _g = useState([]), salesRepList = _g[0], setSalesRepList = _g[1];
    var _h = useState([]), dealerList = _h[0], setDealerList = _h[1];
    var _j = useState(false), dealerListLoading = _j[0], setDealerListLoading = _j[1];
    var _k = useState(false), dealerListLoadingMore = _k[0], setDealerListLoadingMore = _k[1];
    var _l = useState(false), dealerListHasMore = _l[0], setDealerListHasMore = _l[1];
    var _m = useState(""), dealerListError = _m[0], setDealerListError = _m[1];
    var dealerListPageRef = useRef(1);
    var dealerListSearchRef = useRef("");
    var dealerListRequestSeqRef = useRef(0);
    var dealerListFetchedRef = useRef(false);
    var _o = useState([]), programCatalog = _o[0], setProgramCatalog = _o[1];
    var _p = useState([]), masterProgramCatalog = _p[0], setMasterProgramCatalog = _p[1];
    var _q = useState([]), uniqueStatusList = _q[0], setUniqueStatusList = _q[1];
    var _r = useState(""), rerender = _r[0], setRerender = _r[1];
    var navConfig = NavigationConfig;
    var vendorListRequestInFlightRef = useRef(false);
    var masterProgramRequestInFlightRef = useRef(false);
    var salesRepRequestInFlightRef = useRef(false);
    var programListRequestRef = useRef({
        inFlight: false,
        key: "",
    });
    var backlogRequestRef = useRef({
        inFlight: false,
        key: "",
        ts: 0,
    });
    var selectedVendor = filterState.selectedVendor, selectedStatus = filterState.selectedStatus, selectedSavedFilter = filterState.selectedSavedFilter, selectedUniqueStatus = filterState.selectedUniqueStatus, searchText = filterState.searchText, globalSearchText = filterState.globalSearchText, selectedPrograms = filterState.selectedPrograms, currentPage = filterState.currentPage, perPageCount = filterState.perPageCount, sortBy = filterState.sortBy, sortOrder = filterState.sortOrder, selectedSalesRep = filterState.selectedSalesRep, selectedDealers = filterState.selectedDealers, selectedForecastDataRange = filterState.selectedForecastDataRange;
    var pickFirst = useCallback(function () {
        var values = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            values[_i] = arguments[_i];
        }
        for (var _a = 0, values_1 = values; _a < values_1.length; _a++) {
            var value = values_1[_a];
            if (value !== undefined && value !== null) {
                var strVal = String(value).trim();
                if (strVal !== "")
                    return value;
            }
        }
        return undefined;
    }, []);
    var resolvePortalTypeForContract = useCallback(function (item, vendors, programs) {
        var _a, _b, _c, _d, _e, _f;
        var portalTypeFromContract = pickFirst(item === null || item === void 0 ? void 0 : item.PortalType, item === null || item === void 0 ? void 0 : item.OriginType, item === null || item === void 0 ? void 0 : item.DealType, item === null || item === void 0 ? void 0 : item.Portal);
        if (portalTypeFromContract)
            return String(portalTypeFromContract);
        var programById = new Map();
        var programByName = new Map();
        programs.forEach(function (p) {
            if (p === null || p === void 0 ? void 0 : p.Id)
                programById.set(String(p.Id), p);
            if (p === null || p === void 0 ? void 0 : p.ProgramAspireOId)
                programById.set(String(p.ProgramAspireOId), p);
            if (p === null || p === void 0 ? void 0 : p.ProgramAspireId)
                programById.set(String(p.ProgramAspireId), p);
            if (p === null || p === void 0 ? void 0 : p.Name)
                programByName.set(String(p.Name).toLowerCase(), p);
        });
        var programAspireOId = pickFirst(item === null || item === void 0 ? void 0 : item.ProgramAspireOId, item === null || item === void 0 ? void 0 : item.ProgramAspireId, item === null || item === void 0 ? void 0 : item.ProgramAspireOID, item === null || item === void 0 ? void 0 : item.ProgramAspireID, (_a = item === null || item === void 0 ? void 0 : item.Program) === null || _a === void 0 ? void 0 : _a.ProgramAspireOId, (_b = item === null || item === void 0 ? void 0 : item.Program) === null || _b === void 0 ? void 0 : _b.ProgramAspireId);
        var programId = pickFirst(item === null || item === void 0 ? void 0 : item.ProgramId, (_c = item === null || item === void 0 ? void 0 : item.Program) === null || _c === void 0 ? void 0 : _c.Id);
        var programName = pickFirst(item === null || item === void 0 ? void 0 : item.ProgramName, (_d = item === null || item === void 0 ? void 0 : item.Program) === null || _d === void 0 ? void 0 : _d.Name);
        var matchedProgram = (programAspireOId && programById.get(String(programAspireOId))) ||
            (programId && programById.get(String(programId))) ||
            (programName && programByName.get(String(programName).toLowerCase()));
        if (matchedProgram) {
            var portalType = pickFirst(matchedProgram.PortalType, matchedProgram.OriginType, matchedProgram.DealType);
            if (portalType)
                return String(portalType);
        }
        if (matchedProgram && (vendors === null || vendors === void 0 ? void 0 : vendors.length)) {
            var vendorIdFromProgram_1 = pickFirst(matchedProgram.VendorId, matchedProgram.PortalId, (_e = matchedProgram.Vendor) === null || _e === void 0 ? void 0 : _e.Id);
            var vendorNameFromProgram_1 = pickFirst(matchedProgram.VendorName, matchedProgram.PortalName, matchedProgram.Vendor);
            if (vendorIdFromProgram_1) {
                var vendor = vendors.find(function (v) { return String(v === null || v === void 0 ? void 0 : v.Id) === String(vendorIdFromProgram_1); });
                if (vendor === null || vendor === void 0 ? void 0 : vendor.PortalType)
                    return String(vendor.PortalType);
            }
            if (vendorNameFromProgram_1) {
                var vendor = vendors.find(function (v) { var _a; return String((_a = v === null || v === void 0 ? void 0 : v.Name) !== null && _a !== void 0 ? _a : "").toLowerCase() === String(vendorNameFromProgram_1).toLowerCase(); });
                if (vendor === null || vendor === void 0 ? void 0 : vendor.PortalType)
                    return String(vendor.PortalType);
            }
        }
        if (vendors === null || vendors === void 0 ? void 0 : vendors.length) {
            var vendorId_1 = pickFirst(item === null || item === void 0 ? void 0 : item.VendorId, item === null || item === void 0 ? void 0 : item.PortalId, (_f = item === null || item === void 0 ? void 0 : item.Vendor) === null || _f === void 0 ? void 0 : _f.Id, item === null || item === void 0 ? void 0 : item.VendorAspireOId);
            var vendorName_1 = pickFirst(item === null || item === void 0 ? void 0 : item.VendorName, item === null || item === void 0 ? void 0 : item.PortalName, item === null || item === void 0 ? void 0 : item.Vendor);
            var contractProgramName_1 = String(pickFirst(item === null || item === void 0 ? void 0 : item.ProgramName, item === null || item === void 0 ? void 0 : item.Program, "")).toLowerCase();
            if (vendorId_1) {
                var vendor = vendors.find(function (v) { return String(v === null || v === void 0 ? void 0 : v.Id) === String(vendorId_1); });
                if (vendor === null || vendor === void 0 ? void 0 : vendor.PortalType)
                    return String(vendor.PortalType);
            }
            if (vendorName_1) {
                var vendor = vendors.find(function (v) { var _a; return String((_a = v === null || v === void 0 ? void 0 : v.Name) !== null && _a !== void 0 ? _a : "").toLowerCase() === String(vendorName_1).toLowerCase(); });
                if (vendor === null || vendor === void 0 ? void 0 : vendor.PortalType)
                    return String(vendor.PortalType);
            }
            if (contractProgramName_1) {
                var vendor = vendors.find(function (v) {
                    var _a;
                    var vendorNameText = String((_a = v === null || v === void 0 ? void 0 : v.Name) !== null && _a !== void 0 ? _a : "").trim().toLowerCase();
                    return vendorNameText && vendorNameText !== "all" && contractProgramName_1.includes(vendorNameText);
                });
                if (vendor === null || vendor === void 0 ? void 0 : vendor.PortalType)
                    return String(vendor.PortalType);
            }
        }
        if ((selectedVendor === null || selectedVendor === void 0 ? void 0 : selectedVendor.Id) !== "All" && (selectedVendor === null || selectedVendor === void 0 ? void 0 : selectedVendor.PortalType)) {
            return String(selectedVendor.PortalType);
        }
        return "--";
    }, [pickFirst, selectedVendor]);
    var setSelectedVendor = useCallback(function (vendor) {
        dispatch(backlog_actions.updateFilterState({ selectedVendor: vendor }));
    }, [dispatch]);
    var setselectedStatus = useCallback(function (status) {
        dispatch(backlog_actions.updateFilterState({ selectedStatus: status }));
    }, [dispatch]);
    var setSelectedUniqueStatus = useCallback(function (status) {
        dispatch(backlog_actions.updateFilterState({ selectedUniqueStatus: status }));
    }, [dispatch]);
    var setSelectedSavedFilter = useCallback(function (value) {
        dispatch(backlog_actions.updateFilterState({ selectedSavedFilter: value }));
    }, [dispatch]);
    var filteredUniqueStatusList = useMemo(function () {
        if (!(selectedStatus === null || selectedStatus === void 0 ? void 0 : selectedStatus.value) || selectedStatus.value === "All") {
            return uniqueStatusList;
        }
        return uniqueStatusList.filter(function (item) { return item.statusGroup === selectedStatus.value; });
    }, [uniqueStatusList, selectedStatus]);
    var setSearchText = useCallback(function (text) {
        dispatch(backlog_actions.updateFilterState({ searchText: text }));
    }, [dispatch]);
    var setGlobalSearchText = useCallback(function (text) {
        dispatch(backlog_actions.updateFilterState({ globalSearchText: text }));
    }, [dispatch]);
    var setSelectedPrograms = useCallback(function (programs) {
        dispatch(backlog_actions.updateFilterState({ selectedPrograms: programs }));
    }, [dispatch]);
    var setCurrentPage = useCallback(function (page) {
        dispatch(backlog_actions.updateFilterState({ currentPage: page }));
    }, [dispatch]);
    var setPerPageCount = useCallback(function (count) {
        dispatch(backlog_actions.updateFilterState({ perPageCount: count }));
    }, [dispatch]);
    var setBacklogSorting = useCallback(function (nextSortByKey, nextSortOrder) {
        dispatch(backlog_actions.updateFilterState({
            sortBy: nextSortByKey,
            sortOrder: nextSortOrder,
            currentPage: 1,
        }));
    }, [dispatch]);
    useEffect(function () {
        if (selectedPortal)
            setCurrentPage(1);
    }, [selectedPortal]);
    useEffect(function () {
        if (selectedVendor === null || selectedVendor === void 0 ? void 0 : selectedVendor.Id) {
            fetchBacklogAppList();
        }
    }, [
        selectedVendor,
        currentPage,
        perPageCount,
        selectedStatus,
        selectedUniqueStatus,
        searchText,
        globalSearchText,
        selectedPrograms,
        sortBy,
        sortOrder,
        dealCategory,
        selectedSalesRep,
        selectedDealers,
        selectedForecastDataRange
    ]);
    useEffect(function () {
        fetchVendorList();
        fetchMasterProgramCatalog();
        fetchUniqueStatusList();
        if (selectedVendor === null || selectedVendor === void 0 ? void 0 : selectedVendor.Id) {
            fetchProgramsList(selectedVendor.Id !== 'All' ? selectedVendor.Id : undefined);
        }
    }, []);
    var fetchProgramsList = useCallback(function (vendorId) { return __awaiter(_this, void 0, void 0, function () {
        var requestKey, prevRequest, params, res, response, programOptions, err_2;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    requestKey = String(vendorId !== null && vendorId !== void 0 ? vendorId : "All");
                    prevRequest = programListRequestRef.current;
                    if (prevRequest.inFlight && prevRequest.key === requestKey)
                        return [2];
                    programListRequestRef.current = { inFlight: true, key: requestKey };
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    params = vendorId && String(vendorId) !== "All" ? { VendorId: String(vendorId) } : {};
                    return [4, api_service.get({ endPoint: api_urls.BACKLOG_PROGRAMS_LIST, payLoad: params })];
                case 2:
                    res = _b.sent();
                    if (((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.statusCode) === 200) {
                        response = Array.isArray(res.data.data) ? res.data.data : [];
                        setProgramCatalog(response);
                        programOptions = response.map(function (prog) { return ({
                            label: prog.Description,
                            value: prog.Id,
                            ProgramAspireOId: prog.ProgramAspireOId,
                        }); });
                        setProgramsList(programOptions);
                    }
                    return [3, 5];
                case 3:
                    err_2 = _b.sent();
                    setProgramCatalog([]);
                    return [3, 5];
                case 4:
                    programListRequestRef.current.inFlight = false;
                    return [7];
                case 5: return [2];
            }
        });
    }); }, []);
    var fetchMasterProgramCatalog = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var res, response, _a;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (masterProgramRequestInFlightRef.current || masterProgramCatalog.length > 0)
                        return [2];
                    masterProgramRequestInFlightRef.current = true;
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, 4, 5]);
                    return [4, api_service.get({ endPoint: api_urls.PROGRAMS_LIST })];
                case 2:
                    res = _c.sent();
                    if (((_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.statusCode) === 200) {
                        response = Array.isArray(res.data.data) ? res.data.data : [];
                        setMasterProgramCatalog(response);
                    }
                    return [3, 5];
                case 3:
                    _a = _c.sent();
                    setMasterProgramCatalog([]);
                    return [3, 5];
                case 4:
                    masterProgramRequestInFlightRef.current = false;
                    return [7];
                case 5: return [2];
            }
        });
    }); }, [masterProgramCatalog.length]);
    var normalizeSalesRepOptions = useCallback(function (response) {
        var _a, _b;
        var candidateCollections = [
            (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data,
            response === null || response === void 0 ? void 0 : response.data,
        ];
        var rawList = (_b = candidateCollections.find(function (item) { return Array.isArray(item); })) !== null && _b !== void 0 ? _b : [];
        return rawList
            .map(function (item, index) {
            var label = String(item === null || item === void 0 ? void 0 : item.Name).trim();
            var value = item === null || item === void 0 ? void 0 : item.AccountAspireOId;
            return {
                label: label,
                value: value,
            };
        })
            .filter(function (item) { return item.label && item.value !== undefined && item.value !== null; });
    }, []);
    var fetchSalesRepList = useCallback(function (force) {
        if (force === void 0) { force = false; }
        return __awaiter(_this, void 0, void 0, function () {
            var res, err_3;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (salesRepRequestInFlightRef.current)
                            return [2];
                        if (!force && salesRepList.length > 0)
                            return [2];
                        salesRepRequestInFlightRef.current = true;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        return [4, api_service.get({
                                endPoint: api_urls.BACKLOG_SALES_REP,
                                showLoader: false,
                            })];
                    case 2:
                        res = _b.sent();
                        if (((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.statusCode) === 200) {
                            setSalesRepList(normalizeSalesRepOptions(res));
                        }
                        else {
                            setSalesRepList([]);
                        }
                        return [3, 5];
                    case 3:
                        err_3 = _b.sent();
                        setSalesRepList([]);
                        return [3, 5];
                    case 4:
                        salesRepRequestInFlightRef.current = false;
                        return [7];
                    case 5: return [2];
                }
            });
        });
    }, [normalizeSalesRepOptions, salesRepList.length]);
    var normalizeDealerOptions = useCallback(function (response) {
        var _a, _b, _c, _d, _e, _f;
        var candidateCollections = [
            (_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.Dealers,
            (_d = (_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.Rows,
            (_e = response === null || response === void 0 ? void 0 : response.data) === null || _e === void 0 ? void 0 : _e.data,
            response === null || response === void 0 ? void 0 : response.data,
        ];
        var rawList = (_f = candidateCollections.find(function (item) { return Array.isArray(item); })) !== null && _f !== void 0 ? _f : [];
        return rawList
            .map(function (item) {
            var _a, _b, _c, _d;
            var name = String((_b = (_a = item === null || item === void 0 ? void 0 : item.Name) !== null && _a !== void 0 ? _a : item === null || item === void 0 ? void 0 : item.DealerName) !== null && _b !== void 0 ? _b : "").trim();
            var accountAspireId = item === null || item === void 0 ? void 0 : item.AccountAspireId;
            var hasAccountAspireId = accountAspireId !== undefined && accountAspireId !== null && String(accountAspireId).trim() !== "";
            var label = hasAccountAspireId ? "".concat(accountAspireId, " - ").concat(name) : name;
            var accountAspireOId = item === null || item === void 0 ? void 0 : item.AccountAspireOId;
            var value = (_d = (_c = accountAspireOId !== null && accountAspireOId !== void 0 ? accountAspireOId : item === null || item === void 0 ? void 0 : item.Id) !== null && _c !== void 0 ? _c : item === null || item === void 0 ? void 0 : item.DealerId) !== null && _d !== void 0 ? _d : item === null || item === void 0 ? void 0 : item.OId;
            return { label: label, value: value, AccountAspireOId: accountAspireOId };
        })
            .filter(function (item) { return item.label && item.value !== undefined && item.value !== null; });
    }, []);
    var dedupeDealerOptions = useCallback(function (options) {
        var seen = new Set();
        return options.filter(function (option) {
            var key = String(option.value);
            if (seen.has(key))
                return false;
            seen.add(key);
            return true;
        });
    }, []);
    var fetchDealerList = useCallback(function (opts) { return __awaiter(_this, void 0, void 0, function () {
        var vendorId, page, append, searchString, requestSeq, params, res, fetchedOptions_1, fetchedCount, hasMoreByCount, hasMoreByPageFill, err_4;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        return __generator(this, function (_l) {
            switch (_l.label) {
                case 0:
                    vendorId = opts.vendorId, page = opts.page, append = opts.append;
                    searchString = (_a = opts.searchString) !== null && _a !== void 0 ? _a : "";
                    requestSeq = ++dealerListRequestSeqRef.current;
                    if (append) {
                        setDealerListLoadingMore(true);
                    }
                    else {
                        setDealerListLoading(true);
                    }
                    setDealerListError("");
                    _l.label = 1;
                case 1:
                    _l.trys.push([1, 3, 4, 5]);
                    params = {
                        Page: page,
                        Size: DEALER_LIST_PAGE_SIZE,
                        SortBy: "Name",
                        SortOrder: "ASC",
                    };
                    if (vendorId && String(vendorId) !== "All") {
                        params.VendorId = vendorId;
                    }
                    if (searchString) {
                        params.SearchString = searchString;
                    }
                    return [4, api_service.get({
                            endPoint: api_urls.BACKLOG_DEALER_LIST,
                            payLoad: params,
                            showLoader: false,
                        })];
                case 2:
                    res = _l.sent();
                    if (requestSeq !== dealerListRequestSeqRef.current)
                        return [2];
                    if (((_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.statusCode) === 200) {
                        fetchedOptions_1 = normalizeDealerOptions(res);
                        fetchedCount = Number((_k = (_h = (_e = (_d = (_c = res === null || res === void 0 ? void 0 : res.data) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.Count) !== null && _e !== void 0 ? _e : (_g = (_f = res === null || res === void 0 ? void 0 : res.data) === null || _f === void 0 ? void 0 : _f.data) === null || _g === void 0 ? void 0 : _g.TotalCount) !== null && _h !== void 0 ? _h : (_j = res === null || res === void 0 ? void 0 : res.data) === null || _j === void 0 ? void 0 : _j.Count) !== null && _k !== void 0 ? _k : 0);
                        setDealerList(function (prev) {
                            var prevOptions = append ? prev : [];
                            return dedupeDealerOptions(__spreadArray(__spreadArray([], prevOptions, true), fetchedOptions_1, true));
                        });
                        dealerListPageRef.current = page;
                        hasMoreByCount = fetchedCount > 0 ? page * DEALER_LIST_PAGE_SIZE < fetchedCount : false;
                        hasMoreByPageFill = fetchedOptions_1.length === DEALER_LIST_PAGE_SIZE;
                        setDealerListHasMore(hasMoreByCount || hasMoreByPageFill);
                    }
                    else {
                        if (!append)
                            setDealerList([]);
                        setDealerListHasMore(false);
                        setDealerListError("Failed to load dealers.");
                    }
                    return [3, 5];
                case 3:
                    err_4 = _l.sent();
                    if (requestSeq !== dealerListRequestSeqRef.current)
                        return [2];
                    if (!append)
                        setDealerList([]);
                    setDealerListHasMore(false);
                    setDealerListError("Failed to load dealers.");
                    return [3, 5];
                case 4:
                    if (requestSeq === dealerListRequestSeqRef.current) {
                        setDealerListLoading(false);
                        setDealerListLoadingMore(false);
                    }
                    return [7];
                case 5: return [2];
            }
        });
    }); }, [normalizeDealerOptions, dedupeDealerOptions]);
    var fetchDealersByVendor = useCallback(function (vendorId, force) {
        if (force === void 0) { force = false; }
        return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!force && dealerListFetchedRef.current)
                            return [2];
                        dealerListFetchedRef.current = true;
                        dealerListSearchRef.current = "";
                        dealerListPageRef.current = 1;
                        return [4, fetchDealerList({ vendorId: vendorId, searchString: "", page: 1, append: false })];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    }, [fetchDealerList]);
    var searchDealerList = useCallback(function (searchString, vendorId) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dealerListSearchRef.current = searchString !== null && searchString !== void 0 ? searchString : "";
                    dealerListPageRef.current = 1;
                    return [4, fetchDealerList({ vendorId: vendorId, searchString: dealerListSearchRef.current, page: 1, append: false })];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    }); }, [fetchDealerList]);
    var loadMoreDealerList = useCallback(function (vendorId) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (dealerListLoading || dealerListLoadingMore || !dealerListHasMore)
                        return [2];
                    return [4, fetchDealerList({
                            vendorId: vendorId,
                            searchString: dealerListSearchRef.current,
                            page: dealerListPageRef.current + 1,
                            append: true,
                        })];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    }); }, [dealerListLoading, dealerListLoadingMore, dealerListHasMore, fetchDealerList]);
    var fetchUniqueStatusList = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var statusOptions;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, fetchBacklogUniqueStatusOptions()];
                case 1:
                    statusOptions = _a.sent();
                    setUniqueStatusList(statusOptions);
                    return [2];
            }
        });
    }); }, []);
    var fetchBacklogAppList = useCallback(function (programAspireOIds) { return __awaiter(_this, void 0, void 0, function () {
        var effectiveProgramAspireOIds, selectedUniqueStatusValues, payload, dealerOIds, requestKey, now, prevRequest, isDuplicate, res, responseData, __backlogList, __totalCount_1, combinedCatalog_1, __modifiedBacklogList, err_5;
        var _a, _b, _c, _d, _e, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    _g.trys.push([0, 2, 3, 4]);
                    effectiveProgramAspireOIds = ((_a = programAspireOIds === null || programAspireOIds === void 0 ? void 0 : programAspireOIds.length) !== null && _a !== void 0 ? _a : 0) > 0
                        ? (programAspireOIds !== null && programAspireOIds !== void 0 ? programAspireOIds : [])
                        : (_d = (_c = (_b = selectedPrograms === null || selectedPrograms === void 0 ? void 0 : selectedPrograms.map) === null || _b === void 0 ? void 0 : _b.call(selectedPrograms, function (p) { return p === null || p === void 0 ? void 0 : p.ProgramAspireOId; })) === null || _c === void 0 ? void 0 : _c.filter(Boolean)) !== null && _d !== void 0 ? _d : [];
                    selectedUniqueStatusValues = (selectedUniqueStatus !== null && selectedUniqueStatus !== void 0 ? selectedUniqueStatus : [])
                        .map(function (status) { return status === null || status === void 0 ? void 0 : status.label; })
                        .filter(function (value) { return value !== undefined && value !== null && value !== ""; });
                    payload = {
                        Page: globalSearchText ? 1 : currentPage,
                        Size: perPageCount,
                        SearchString: searchText !== null && searchText !== void 0 ? searchText : "",
                    };
                    if ((selectedVendor === null || selectedVendor === void 0 ? void 0 : selectedVendor.Id) && selectedVendor.Id !== "All") {
                        payload.VendorId = selectedVendor.Id;
                    }
                    if (selectedUniqueStatusValues.length > 0) {
                        payload.ContractStatus = selectedUniqueStatusValues;
                    }
                    if ((selectedStatus === null || selectedStatus === void 0 ? void 0 : selectedStatus.value) && selectedStatus.value !== "All") {
                        payload.StatusGroup = selectedStatus.value;
                    }
                    if ((selectedSalesRep === null || selectedSalesRep === void 0 ? void 0 : selectedSalesRep.length) > 0) {
                        payload.InternalSalesRepOId = selectedSalesRep.map(function (rep) { return rep.value; }).join(",");
                    }
                    if ((selectedDealers === null || selectedDealers === void 0 ? void 0 : selectedDealers.length) > 0) {
                        dealerOIds = selectedDealers
                            .map(function (dealer) { var _a; return (_a = dealer.AccountAspireOId) !== null && _a !== void 0 ? _a : dealer.value; })
                            .filter(function (oid) { return oid !== undefined && oid !== null && oid !== ""; })
                            .map(function (oid) { return String(oid); });
                        if (dealerOIds.length > 0) {
                            payload.DealerOIds = dealerOIds;
                        }
                    }
                    if (effectiveProgramAspireOIds.length > 0) {
                        payload.ProgramAspireOIds = effectiveProgramAspireOIds;
                    }
                    if (selectedForecastDataRange === null || selectedForecastDataRange === void 0 ? void 0 : selectedForecastDataRange.StartDate) {
                        payload.ForecastDataRange = {
                            StartDate: selectedForecastDataRange.StartDate,
                            EndDate: selectedForecastDataRange.EndDate || selectedForecastDataRange.StartDate,
                        };
                    }
                    if (sortBy) {
                        payload.SortBy = sortBy;
                        payload.SortOrder = sortOrder;
                    }
                    payload.DealCategory = dealCategory;
                    requestKey = JSON.stringify(payload);
                    now = Date.now();
                    prevRequest = backlogRequestRef.current;
                    isDuplicate = prevRequest.key === requestKey && (prevRequest.inFlight || now - prevRequest.ts < 800);
                    if (isDuplicate)
                        return [2];
                    backlogRequestRef.current = { inFlight: true, key: requestKey, ts: now };
                    setIsFetching(true);
                    setBacklogAppList([]);
                    return [4, api_service.post({
                            endPoint: api_urls.GET_TOTAL_CONTRACTS,
                            payLoad: payload,
                        })];
                case 1:
                    res = _g.sent();
                    setIsFetching(false);
                    if ((res === null || res === void 0 ? void 0 : res.data) && res.data.statusCode === 200) {
                        responseData = (_e = res === null || res === void 0 ? void 0 : res.data) === null || _e === void 0 ? void 0 : _e.data;
                        __backlogList = Array.isArray(responseData)
                            ? responseData
                            : Array.isArray(responseData === null || responseData === void 0 ? void 0 : responseData.Contracts) ? responseData.Contracts
                                : Array.isArray(responseData === null || responseData === void 0 ? void 0 : responseData.contracts) ? responseData.contracts
                                    : Array.isArray(responseData === null || responseData === void 0 ? void 0 : responseData.Rows) ? responseData.Rows
                                        : Array.isArray(responseData === null || responseData === void 0 ? void 0 : responseData.rows) ? responseData.rows
                                            : [];
                        __totalCount_1 = Number((_f = pickFirst(responseData === null || responseData === void 0 ? void 0 : responseData.Count, responseData === null || responseData === void 0 ? void 0 : responseData.count, responseData === null || responseData === void 0 ? void 0 : responseData.TotalCount, responseData === null || responseData === void 0 ? void 0 : responseData.totalCount, responseData === null || responseData === void 0 ? void 0 : responseData.Total, responseData === null || responseData === void 0 ? void 0 : responseData.total, __backlogList.length > 0 ? __backlogList.length : 0)) !== null && _f !== void 0 ? _f : 0);
                        combinedCatalog_1 = __spreadArray(__spreadArray([], programCatalog, true), masterProgramCatalog, true);
                        __modifiedBacklogList = __backlogList.map(function (item) { return (__assign(__assign({}, item), { PortalType: resolvePortalTypeForContract(item, vendorList, combinedCatalog_1), CreatedTime: item.CreatedTime ? moment(item.CreatedTime).utcOffset(0) : "", LastModifiedTime: item.LastModifiedTime ? moment(item.LastModifiedTime).utcOffset(0) : "" })); });
                        setBacklogAppList(__modifiedBacklogList);
                        setTotalCount(function (prevCount) { return (prevCount !== __totalCount_1 ? __totalCount_1 : prevCount); });
                    }
                    return [3, 4];
                case 2:
                    err_5 = _g.sent();
                    setIsFetching(false);
                    return [3, 4];
                case 3:
                    backlogRequestRef.current.inFlight = false;
                    return [7];
                case 4: return [2];
            }
        });
    }); }, [
        selectedVendor,
        selectedStatus,
        selectedUniqueStatus,
        searchText,
        globalSearchText,
        currentPage,
        perPageCount,
        selectedPrograms,
        vendorList,
        programCatalog,
        masterProgramCatalog,
        resolvePortalTypeForContract,
        pickFirst,
        sortBy,
        sortOrder,
        dealCategory,
        selectedSalesRep,
        selectedDealers,
        selectedForecastDataRange,
    ]);
    useEffect(function () {
        if (!backlogAppList.length) {
            return;
        }
        setBacklogAppList(function (prevList) {
            var hasChanges = false;
            var combinedProgramCatalog = __spreadArray(__spreadArray([], programCatalog, true), masterProgramCatalog, true);
            var updatedList = prevList.map(function (item) {
                var _a;
                var resolvedPortalType = resolvePortalTypeForContract(item, vendorList, combinedProgramCatalog);
                if (String((_a = item === null || item === void 0 ? void 0 : item.PortalType) !== null && _a !== void 0 ? _a : "") === String(resolvedPortalType)) {
                    return item;
                }
                hasChanges = true;
                return __assign(__assign({}, item), { PortalType: resolvedPortalType });
            });
            return hasChanges ? updatedList : prevList;
        });
    }, [programCatalog, masterProgramCatalog, vendorList, resolvePortalTypeForContract]);
    var debouncedFetchBacklogAppList = useCallback(_.debounce(function () {
        fetchBacklogAppList();
    }, 2000), [fetchBacklogAppList]);
    var fetchVendorList = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var res, vendorListData, exists;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (vendorListRequestInFlightRef.current || (vendorList === null || vendorList === void 0 ? void 0 : vendorList.length))
                        return [2];
                    vendorListRequestInFlightRef.current = true;
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, , 3, 4]);
                    return [4, api_service.get({ endPoint: api_urls.VENDOR_LIST })];
                case 2:
                    res = _b.sent();
                    if (((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.statusCode) === 200) {
                        vendorListData = __spreadArray([{ Id: "All", Name: "All" }], (res.data.data || []), true);
                        setVendorList(vendorListData);
                        if ((selectedVendor === null || selectedVendor === void 0 ? void 0 : selectedVendor.Id) && selectedVendor.Id !== "All") {
                            exists = vendorListData.some(function (v) { return String(v.Id) === String(selectedVendor.Id); });
                            if (exists)
                                setSelectedVendor(selectedVendor);
                        }
                    }
                    return [3, 4];
                case 3:
                    vendorListRequestInFlightRef.current = false;
                    return [7];
                case 4: return [2];
            }
        });
    }); }, [selectedVendor, setSelectedVendor, vendorList === null || vendorList === void 0 ? void 0 : vendorList.length]);
    var handlePortalSelection = useCallback(function (e) {
        var value = e.target.value;
        var vendor = vendorList === null || vendorList === void 0 ? void 0 : vendorList.find(function (item) { return item.Id === value; });
        var resolvedVendor = vendor
            ? vendor
            : { Id: String(value), Name: "" };
        setSelectedVendor(resolvedVendor);
        fetchProgramsList(value);
        setSelectedPrograms([]);
    }, [vendorList, fetchProgramsList, setSelectedVendor, setSelectedPrograms]);
    var handleStatusGroupSelection = useCallback(function (e) {
        var _a;
        var value = e.target.value;
        var status = BacklogStatusGroups === null || BacklogStatusGroups === void 0 ? void 0 : BacklogStatusGroups.find(function (item) { return item.value === value; });
        setselectedStatus({ label: (_a = status === null || status === void 0 ? void 0 : status.label) !== null && _a !== void 0 ? _a : "", value: value });
        setSelectedUniqueStatus([]);
    }, [setselectedStatus, setSelectedUniqueStatus]);
    var handleUniqueStatusSelection = useCallback(function (event, values) {
        setSelectedUniqueStatus(values !== null && values !== void 0 ? values : []);
    }, [setSelectedUniqueStatus]);
    var onSearchComplete = useCallback(function (value) {
        if ((value && value.length > 0) || value === "")
            setSearchText(value !== null && value !== void 0 ? value : "");
    }, [setSearchText]);
    var onGlobalSearchComplete = useCallback(function (value) {
        if ((value && value.length > 0) || value === "")
            setGlobalSearchText(value !== null && value !== void 0 ? value : "");
    }, [setGlobalSearchText]);
    var handleProgramSelection = useCallback(function (event, values) {
        setSelectedPrograms(values);
    }, [setSelectedPrograms]);
    var applyBacklogFilters = useCallback(function (filters) {
        var _a, _b, _c, _d;
        var vendor = (_a = filters === null || filters === void 0 ? void 0 : filters.vendor) !== null && _a !== void 0 ? _a : { Id: "All", Name: "All" };
        var status = (_b = filters === null || filters === void 0 ? void 0 : filters.status) !== null && _b !== void 0 ? _b : { label: "All", value: "All" };
        var programs = Array.isArray(filters === null || filters === void 0 ? void 0 : filters.programs) ? filters.programs : [];
        var nextSearchText = (_c = filters === null || filters === void 0 ? void 0 : filters.searchText) !== null && _c !== void 0 ? _c : "";
        var uniqueStatus = Array.isArray(filters === null || filters === void 0 ? void 0 : filters.uniqueStatus) ? filters.uniqueStatus : [];
        var salesRep = Array.isArray(filters === null || filters === void 0 ? void 0 : filters.salesRep) ? filters.salesRep : [];
        var dealers = Array.isArray(filters === null || filters === void 0 ? void 0 : filters.dealers) ? filters.dealers : [];
        var nextForecastDataRange = ((_d = filters === null || filters === void 0 ? void 0 : filters.ForecastDataRange) === null || _d === void 0 ? void 0 : _d.StartDate)
            ? {
                StartDate: String(filters.ForecastDataRange.StartDate),
                EndDate: String(filters.ForecastDataRange.EndDate || filters.ForecastDataRange.StartDate),
            }
            : { StartDate: "", EndDate: "" };
        dispatch(backlog_actions.updateFilterState({
            selectedVendor: vendor,
            selectedStatus: status,
            selectedUniqueStatus: uniqueStatus,
            searchText: nextSearchText,
            selectedPrograms: programs,
            currentPage: 1,
            selectedSalesRep: salesRep,
            selectedDealers: dealers,
            selectedForecastDataRange: nextForecastDataRange,
        }));
        fetchProgramsList((vendor === null || vendor === void 0 ? void 0 : vendor.Id) !== "All" ? vendor === null || vendor === void 0 ? void 0 : vendor.Id : undefined);
    }, [dispatch, fetchProgramsList]);
    var handleProgramBlur = useCallback(function (e) {
    }, []);
    var handleResetFilters = useCallback(function () {
        dispatch(backlog_actions.resetCurrentTabFilters());
        setBacklogAppList([]);
        setRerender(JSON.stringify(Date.now()));
    }, [dispatch]);
    var handleTableSortChange = useCallback(function (nextSortByKey, nextSortOrder) {
        setBacklogSorting(nextSortByKey, nextSortOrder);
    }, [setBacklogSorting]);
    return {
        backlogAppList: backlogAppList,
        isFetching: isFetching,
        selectedPortal: selectedPortal,
        setSelectedPortal: setSelectedPortal,
        selectedStatus: selectedStatus,
        setselectedStatus: setselectedStatus,
        selectedSavedFilter: selectedSavedFilter,
        setSelectedSavedFilter: setSelectedSavedFilter,
        selectedUniqueStatus: selectedUniqueStatus,
        setSelectedUniqueStatus: setSelectedUniqueStatus,
        allUniqueStatusList: uniqueStatusList,
        uniqueStatusList: filteredUniqueStatusList,
        vendorList: vendorList,
        selectedVendor: selectedVendor,
        setSelectedVendor: setSelectedVendor,
        currentPage: currentPage,
        setCurrentPage: setCurrentPage,
        perPageCount: perPageCount,
        setPerPageCount: setPerPageCount,
        totalCount: totalCount,
        searchText: searchText,
        setSearchText: setSearchText,
        globalSearchText: globalSearchText,
        setGlobalSearchText: setGlobalSearchText,
        navConfig: navConfig,
        handlePortalSelection: handlePortalSelection,
        handleStatusGroupSelection: handleStatusGroupSelection,
        handleUniqueStatusSelection: handleUniqueStatusSelection,
        onSearchComplete: onSearchComplete,
        onGlobalSearchComplete: onGlobalSearchComplete,
        handleResetFilters: handleResetFilters,
        programsList: programsList,
        fetchProgramsByVendor: fetchProgramsList,
        salesRepList: salesRepList,
        fetchSalesRepList: fetchSalesRepList,
        dealerList: dealerList,
        dealerListLoading: dealerListLoading,
        dealerListLoadingMore: dealerListLoadingMore,
        dealerListHasMore: dealerListHasMore,
        dealerListError: dealerListError,
        fetchDealersByVendor: fetchDealersByVendor,
        searchDealerList: searchDealerList,
        loadMoreDealerList: loadMoreDealerList,
        selectedPrograms: selectedPrograms,
        handleProgramSelection: handleProgramSelection,
        applyBacklogFilters: applyBacklogFilters,
        handleProgramBlur: handleProgramBlur,
        rerender: rerender,
        sortBy: sortBy,
        sortOrder: sortOrder,
        handleTableSortChange: handleTableSortChange,
        selectedSalesRep: selectedSalesRep,
        selectedDealers: selectedDealers,
        selectedForecastDataRange: selectedForecastDataRange,
    };
}
